/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

import { Client, UserRepository } from '@amityco/ts-sdk';

// import Config from 'react-native-config';
import { useAppSelector } from '@store';
import { setUserAmityId } from 'src/store/login/LoginSlice';
import { useDispatch } from 'react-redux';
import api from 'src/services';
import { getFollowers } from 'src/services/social';
import { Driver, FleetUser, GroupFleet, UserChat } from '@types';
import { fetchDriverListV1 } from 'src/services/routes';
import { getUsersFleet } from 'src/services/fleets';

export type TFollowers = {
  [x: string]: Amity.User;
}
export type TDrivers = {
  [x: string]: any;
}


export type TAuthContext = {
  error: string;
  isConnecting: boolean;
  logout: () => void;
  client?: Amity.Client | {};
  login: () => Promise<void>;
  isConnected: boolean;
  sessionState: string;
  followers: TFollowers;
  amityRioDrivers: TFollowers;
  rioDrivers: TDrivers;
  allUsers: UserChat[];
  profileId: string;
  getDetailUser?: (id?: string) => Amity.User;
  all: any;
  finderDriverFleet?: (driverId: string) => {}
};

export const AuthContext = React.createContext<TAuthContext>({
  client: {},
  isConnecting: false,
  error: '',
  login: async () => { },
  logout: () => { },
  isConnected: false,
  sessionState: '',
  followers: {},
  amityRioDrivers: {},
  rioDrivers: {},
  allUsers: [],
  profileId: '',
  all: [],
});

export const AuthContextProvider = ({
  children,
}: {
  children: React.JSX.Element;
}) => {
  const profile = useAppSelector(state => state.login.userProfile);
  const apiKey = process.env.REACT_APP_CHAT_API_KEY || '';
  const apiRegion = process.env.REACT_APP_CHAT_API_REGION;
  const [error, setError] = useState('');
  const [isConnecting, setLoading] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const dispatch = useDispatch();
  const [sessionState, setSessionState] = useState('');
  const [client] = useState(Client.createClient(apiKey, apiRegion));
  const [profileId, setProfileId] = useState('');
  const [followers, setFollowers] = useState({});
  const [amityRioDrivers, setAmityRioDrivers] = useState<TFollowers>({});
  const [rioDrivers, setRioDrivers] = useState({});
  const [allUsers, setAllUsers] = useState<UserChat[]>([]);
  const [all, setAll] = useState()
  const [isRunningList, setIsRunningList] = useState(false);
  const [isRunningUsers, setIsRunningUsers] = useState(false);
  const [hasLoadedList, setHasLoadedList] = useState(false);

  const [sessionHandler] = useState<Amity.SessionHandler>({
    sessionWillRenewAccessToken(renewal) {
      try {
        renewal.renew();
      } catch (error) { }
    },
  });

  useEffect(() => {
    return Client.onSessionStateChange((state: Amity.SessionStates) => {
      setSessionState(state);
    });
  }, []);

  const startSync = () => {
    if (Client.isConnected() && sessionState === 'established') {
      try {
        Client.enableUnreadCount();
      } catch (error) { }
    } else {
    }
  };

  useEffect(() => {
    if (sessionState === 'established') {
      startSync();
      setIsConnected(true);
    } else {
      setIsConnected(false);
    }
  }, [sessionState]);

  const handleConnect = async () => {
    if (profile?.sub) {
      try {
        const resUnique = await api.get('/v1/users/unique/profile');

        dispatch(setUserAmityId(resUnique.data.id));
        setProfileId(resUnique.data.id)

        await Client.login(
          {
            userId: resUnique.data.id,
            displayName: resUnique.data.id,
          },
          sessionHandler,
        );
      } catch (error) {
        console.error(error)
      }
    }
  };

  const login = async () => {
    setError('');
    setLoading(true);
    try {
     await handleConnect();
    } catch (e) {
      const errorText =
        (e as Error)?.message ?? 'Error while handling request!';

      setError(errorText);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isConnected && sessionState !== 'established') {
      login();
    }
  }, [profile]);

  const logout = async () => {
    try {
      // Client.stopUnreadSync();
      await Client.logout();
    } catch (e) { }
  };

  const fetchFollowerAndFollowing = async () => {
    if (!profileId) {
      return;
    }
    try {
      const resFollowers = await getFollowers(profileId);
      const followersReducer = resFollowers.data.result.users.reduce((acc: { [x: string]: Amity.User }, item: Amity.User) => {
        acc[item.userId] = item;
        return acc;
      }, {});
      setFollowers(followersReducer);
    } catch (error) {
      console.error('[AuthProvider] Erro ao buscar followers:', error);
    }
  };

  const getDetailUserByRio = async () => {
    try {
      const responseRioDrivers = await fetchDriverListV1();

      const drivers = responseRioDrivers?.data?.result?.drivers;

      const idsDriversRio = drivers
        ?.map((res: Driver) => res.uniqueProfileId || res.userId)
        ?.filter((id: any): id is string => !!id && typeof id === 'string' && id.trim().length > 0);

      let transform: { [x: string]: Amity.User } = {};
      
      // Só buscar usuários do Amity se houver IDs válidos
      if (idsDriversRio && idsDriversRio.length > 0) {
        try {
          const resUserAmityRio = await UserRepository.getUserByIds(idsDriversRio);
          if (resUserAmityRio?.data) {
            transform = resUserAmityRio.data.reduce((acc: { [x: string]: Amity.User }, item: Amity.User) => {
              acc[item.userId] = item;
              return acc;
            }, {});
          }
        } catch (amityError) {
          console.warn('[AuthProvider] Erro ao buscar usuários do Amity (não crítico):', amityError);
          // Continua mesmo se houver erro no Amity
        }
      }

      const transformRioDrivers = drivers?.filter((res: any) => res.uniqueProfileId || res.userId).reduce((acc: any, item: any) => {
        acc[item.uniqueProfileId ?? item.userId] = item;
        return acc;
      }, {});

      setRioDrivers(transformRioDrivers);
      setAmityRioDrivers(transform);
      setAll(drivers);
    } catch (error) {
      console.error('[AuthProvider] ERRO ao buscar motoristas do Rio:', error);
    }
  };

  const runList = async () => {
    if (isRunningList || hasLoadedList) return;
    setIsRunningList(true);
    try {
      await fetchFollowerAndFollowing();
      await getDetailUserByRio();
      setHasLoadedList(true);
    } finally {
      setIsRunningList(false);
    }
  }

  useEffect(() => {
    if (sessionState === 'established' && profileId && !hasLoadedList) {
      runList();
    }
  }, [sessionState, profileId, hasLoadedList]);

  const getAllUsers = async () => {
    if (!profileId) {
      return;
    }
    try {
      const res = await getUsersFleet();
      const resFollowers = await getFollowers(profileId);

    const rioUsers: UserChat[] = res.data.result.map((driver: FleetUser): UserChat => {
      const metadataRioUser = amityRioDrivers?.[driver.uniqueProfileId as string]?.metadata;

      const name = metadataRioUser?.displayName
        ? metadataRioUser.displayName
        : metadataRioUser?.givenName && metadataRioUser?.familyName
          ? metadataRioUser.givenName + " " + metadataRioUser.familyName
          : driver.name;

      const img = amityRioDrivers?.[driver.uniqueProfileId as string]?.metadata?.imageProfile?.fileUrl;

      return {
        id: driver.id,
        uniqueProfileId: driver.uniqueProfileId,
        name: name,
        userId: driver.userId,
        avatar: img,
        isManager: driver.groups.some((res: GroupFleet) => res.description === 'Fleet admin')
      };
    });

    const followerList: UserChat[] = resFollowers.data?.result?.users?.filter((amity: Amity.User) => !rioUsers?.some((userRio: UserChat) => userRio.uniqueProfileId === amity.userId || userRio.userId === amity.userId))
      .map((user: Amity.User): UserChat => {
        const metadata = user?.metadata;
        const name = metadata?.displayName || metadata?.givenName + " " + metadata?.familyName;
        const img = metadata?.imageProfile?.fileUrl;

        return {
          id: user._id,
          name: name,
          uniqueProfileId: user.userId,
          userId: null,
          avatar: img,
          isManager: user?.metadata?.profileType === 'MANAGER',
        };
      });

    const grouped: UserChat[] = [...followerList, ...rioUsers];
    // const removed = grouped?.filter((value, index, self) =>
    //   index === self?.findIndex((t) => t.userId === value.userId)
    // );

    setAllUsers(grouped.sort((a, b) => {
      if (!a.name && !b.name) return 0;
      if (!a.name) return 1;
      if (!b.name) return -1;
      return a.name.localeCompare(b.name);
    }));
    } catch (error) {
      console.error('[AuthProvider] Erro ao buscar todos os usuários:', error);
    }
  };

  const getDetailUser = (profileId?: string): Amity.User => {
    const a: Record<string, Amity.User> = amityRioDrivers;
    const fo: Record<string, Amity.User> = followers;

    const r = a[profileId!];
    const f = fo[profileId!];

    return r || f!;
  };

  const finderDriverFleet = (driverId: string) => {
    const cop: any = all;
    const driver = cop?.find((res: {userId: string}) => res?.userId === driverId);
    return driver;
  }

  useEffect(() => {
    if (sessionState === 'established' && profileId && hasLoadedList && !isRunningUsers) {
      setIsRunningUsers(true);
      getAllUsers().finally(() => setIsRunningUsers(false));
    }
  }, [sessionState, profileId, hasLoadedList]);

  return (
    <AuthContext.Provider
      value={{
        error,
        isConnecting,
        login,
        client,
        logout,
        isConnected,
        sessionState,
        followers,
        amityRioDrivers,
        rioDrivers,
        allUsers,
        profileId,
        getDetailUser,
        all,
        finderDriverFleet,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
